<template>
  <Card
    :class="$style.card"
  >
    <Grid :class="$style.cardGrid">
      <GridItem
        :class="$style.cardBody"
        :gridSpan="12"
      >
        <HeadingLarge>
          Implement JumpCloud after your purchase
        </HeadingLarge>
        <ParagraphBody>
          Use our Implementation Guides to understand the next steps of your
          JumpCloud rollout.
        </ParagraphBody>
        <div :class="$style.buttonContainer">
          <Button
            text="View Guides"
            @click="handleViewGuides"
          />

          <Button
            :class="$style.consultationBtn"
            data-test-id="ImplementationGuideCard__consultationButton"
            :outline="true"
            target="_blank"
            text="Free Consultation"
            type="secondary"
            @click="handleCalendlyLinkClick"
          />
        </div>
      </GridItem>
      <GridItem
        :class="$style.customIcon"
        :gridSpan="5"
      >
        <img
          :class="$style.illustration"
          :src="illustrationSource"
        >
      </GridItem>
    </Grid>
  </Card>
</template>

<script>
import {
  Button,
  Card,
  Grid,
  GridItem,
  HeadingLarge,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { S3BucketAddress } from 'client/util/Constants/ApplicationConstants';
import { eventLocations, eventProperties, freeSpecialistLink } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  text,
  section,
  toUrl,
} = eventProperties;

const {
  pricingPage,
} = eventLocations;

export default {
  name: 'ImplementationGuideCard',

  EventHelper,
  Util,

  components: {
    Button,
    Card,
    Grid,
    GridItem,
    HeadingLarge,
    ParagraphBody,
  },

  data: () => ({
    illustrationSource: `${S3BucketAddress}/illustrations/implemention-guide.svg`,
  }),

  methods: {
    handleCalendlyLinkClick() {
      this.$options.Util.openUrl(freeSpecialistLink);
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Opens Calendly Link for Free Consultation',
        [location]: pricingPage,
        [section]: 'Implementation Guide Card',
        [text]: 'Free Consultation',
      });
    },

    handleViewGuides() {
      const implementationGuideRoute = ItemTypeRoutes[ItemTypeConsts.implementationGuide];
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'open implementation guide page',
        [location]: pricingPage,
        [section]: 'Implementation Guide Card',
        [text]: 'View Guides',
        [toUrl]: implementationGuideRoute,
      });
      this.$router.push(implementationGuideRoute);
    },
  },
};
</script>

<style module scoped>
@import './css/customerSupportCard.css';

.cardGrid {
  align-items: flex-start;
}

.illustration {
  height: 12rem;
}

.buttonContainer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-spacer-small);
}

</style>
